module.exports = __webpack_public_path__ + "img/selected1-min.d8f418ed.png";